import React from "react";
import { Box, Stack, Theme, useTheme } from "@mui/material";
import { Stock } from "../../../../../../models/Stock/Stock";
import CustomTypography from "../../../../../../views/components/common/form/CustomTypography";
import {
  getModernPageColors,
  modernEmptyStateSx,
} from "../../../../../../styles/modernListingPageSx";
import StockCheckRequestCard from "./StockCheckRequestCard";
import AppTablePagenation from "../../../../../../views/components/common/pages/AppTablePagenation";

interface StockTableProp {
  stocks: Stock[];
  page_no: number;
  total_count: number;
  limit: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => void;
  onRowsPerPageChange: (limit: number) => void;
}

const StockTable = ({
  stocks,
  page_no,
  limit,
  total_count,
  onPageChange,
  onRowsPerPageChange,
}: StockTableProp) => {
  const theme = useTheme<Theme>();
  const colors = getModernPageColors(theme);

  return (
    <Box sx={{ width: "100%", backgroundColor: colors.surface }}>
      <Box
        sx={{
          px: { xs: 1.5, sm: 2 },
          py: { xs: 1.5, sm: 2 },
          borderBottom: `1px solid ${colors.border}`,
          backgroundColor: colors.surfaceMuted,
        }}
      >
        <CustomTypography variant="heading7" fontWeight={700} color={colors.title}>
          Stock check requests
        </CustomTypography>
        <CustomTypography variant="caption" color={colors.subtitle}>
          {`${total_count} total requests`}
        </CustomTypography>
      </Box>

      {stocks.length > 0 ? (
        <Box
          sx={{
            maxHeight: "calc(100vh - 340px)",
            overflowY: "auto",
            p: { xs: 1, sm: 1.5 },
            backgroundColor: colors.pageBg,
          }}
        >
          <Stack spacing={1}>
            {stocks.map((stock) => (
              <StockCheckRequestCard key={stock.id} stock={stock} />
            ))}
          </Stack>
        </Box>
      ) : (
        <Box
          sx={{
            ...modernEmptyStateSx(theme),
            p: 4,
            borderTop: "1px solid",
            borderColor: "divider",
            backgroundColor: colors.surface,
          }}
        >
          <CustomTypography
            variant="heading6"
            fontWeight={600}
            color={colors.subtitle}
          >
            No stock check requests match these filters.
          </CustomTypography>
        </Box>
      )}

      {total_count > 0 && (
        <Box
          sx={{
            borderTop: "1px solid",
            borderColor: "divider",
            backgroundColor: colors.surface,
          }}
        >
          <AppTablePagenation
            fontSize="0.8rem"
            fontColor={colors.subtitle}
            totalCount={total_count}
            limit={limit}
            pageNo={page_no}
            onPageChange={onPageChange}
            handleRowsChange={onRowsPerPageChange}
          />
        </Box>
      )}
    </Box>
  );
};

export default StockTable;
